module.exports = __webpack_public_path__ + "assets/img/block-left-e76c7733.png";